// @flow

export const SAVE_NAME_BUTTON_FOCUS_KEY = 'SAVE_NAME_BUTTON_FOCUS_KEY'
export const PROFILE_NAME_INPUT_FOCUS_KEY = 'PROFILE_NAME_INPUT_FOCUS_KEY'
